/**
 * Saved ship-to addresses per patient (patient_shipping_addresses). Fed
 * automatically by every ship-to-patient integration order (Axiom, SiPhox,
 * Genova, TruDiagnostic) — the backend upserts the address an order ships to —
 * and read here to populate the "saved addresses" picker in the order modals.
 */
import { apiClient } from './apiClient';

export interface PatientShippingAddress {
  patientShippingAddressId: number;
  recipientName: string;
  phone: string | null;
  line1: string;
  line2: string | null;
  city: string;
  state: string;
  zip: string;
  country: string;
  lastUsedAt: string | null;
}

export async function getPatientShippingAddresses(patientId: number): Promise<PatientShippingAddress[]> {
  const res = await apiClient.get<{ data: PatientShippingAddress[] }>(
    `/patients/${patientId}/shipping-addresses`,
  );
  return res.data.data ?? [];
}

export async function deletePatientShippingAddress(patientId: number, addressId: number): Promise<void> {
  await apiClient.delete(`/patients/${patientId}/shipping-addresses/${addressId}`);
}

export interface NewShippingAddress {
  recipientName: string;
  phone?: string | null;
  line1: string;
  line2?: string | null;
  city: string;
  state: string;
  zip: string;
  country?: string | null;
}

/** Save a delivery address to the patient's address book (idempotent upsert). */
export async function savePatientShippingAddress(
  patientId: number,
  address: NewShippingAddress,
): Promise<PatientShippingAddress> {
  const res = await apiClient.post<{ data: PatientShippingAddress }>(
    `/patients/${patientId}/shipping-addresses`,
    address,
  );
  return res.data.data;
}
